'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';

/** Brand configuration for placeholder colors - matches Scenario website palette */
const BRAND_CONFIG = {
  // 3D Model brands
  hunyuan: {
    bg: 'bg-emerald-500',
    text: 'text-white',
    label: 'Tencent 腾讯'
  },
  tencent: {
    bg: 'bg-emerald-500',
    text: 'text-white',
    label: 'Tencent 腾讯'
  },
  meshy: {
    bg: 'bg-emerald-500',
    text: 'text-white',
    label: 'Meshy.ai'
  },
  tripo: {
    bg: 'bg-purple-950',
    text: 'text-white',
    label: 'TRIPO'
  },
  rodin: {
    bg: 'bg-rose-700',
    text: 'text-white',
    label: 'scenario'
  },
  sparc3d: {
    bg: 'bg-amber-900',
    text: 'text-white',
    label: 'Hitem3D'
  },
  hitem3d: {
    bg: 'bg-amber-900',
    text: 'text-white',
    label: 'Hitem3D'
  },
  voxel: {
    bg: 'bg-emerald-600',
    text: 'text-white',
    label: 'scenario'
  },
  partcrafter: {
    bg: 'bg-sky-100',
    text: 'text-gray-800',
    label: ''
  },
  direct3d: {
    bg: 'bg-yellow-400',
    text: 'text-gray-800',
    label: 'Neural4D'
  },
  neural4d: {
    bg: 'bg-yellow-400',
    text: 'text-gray-800',
    label: 'Neural4D'
  },
  trellis: {
    bg: 'bg-gray-200',
    text: 'text-gray-700',
    label: 'Microsoft'
  },
  microsoft: {
    bg: 'bg-gray-200',
    text: 'text-gray-700',
    label: 'Microsoft'
  },
  // Image generation brands
  flux: {
    bg: 'bg-violet-950',
    text: 'text-white',
    label: 'Black Forest Labs'
  },
  'black forest': {
    bg: 'bg-violet-950',
    text: 'text-white',
    label: 'Black Forest Labs'
  },
  sdxl: {
    bg: 'bg-orange-500',
    text: 'text-white',
    label: 'Stability AI'
  },
  'stable-diffusion': {
    bg: 'bg-orange-500',
    text: 'text-white',
    label: 'Stability AI'
  },
  'stable diffusion': {
    bg: 'bg-orange-500',
    text: 'text-white',
    label: 'Stability AI'
  },
  stability: {
    bg: 'bg-orange-500',
    text: 'text-white',
    label: 'Stability AI'
  },
  gemini: {
    bg: 'bg-pink-300',
    text: 'text-gray-800',
    label: 'Google'
  },
  google: {
    bg: 'bg-green-300',
    text: 'text-gray-800',
    label: 'Google'
  },
  imagen: {
    bg: 'bg-blue-500',
    text: 'text-white',
    label: 'Google'
  },
  gpt: {
    bg: 'bg-emerald-600',
    text: 'text-white',
    label: 'OpenAI'
  },
  openai: {
    bg: 'bg-emerald-600',
    text: 'text-white',
    label: 'OpenAI'
  },
  'dall-e': {
    bg: 'bg-emerald-600',
    text: 'text-white',
    label: 'OpenAI'
  },
  dalle: {
    bg: 'bg-emerald-600',
    text: 'text-white',
    label: 'OpenAI'
  },
  'p-image': {
    bg: 'bg-purple-600',
    text: 'text-white',
    label: 'Pruna AI'
  },
  pruna: {
    bg: 'bg-purple-600',
    text: 'text-white',
    label: 'Pruna AI'
  },
  seedream: {
    bg: 'bg-violet-200',
    text: 'text-gray-800',
    label: 'ByteDance'
  },
  bytedance: {
    bg: 'bg-violet-200',
    text: 'text-gray-800',
    label: 'ByteDance'
  },
  'z-image': {
    bg: 'bg-violet-200',
    text: 'text-gray-800',
    label: 'ByteDance'
  },
  dreamina: {
    bg: 'bg-pink-200',
    text: 'text-gray-800',
    label: ''
  },
  reve: {
    bg: 'bg-indigo-400',
    text: 'text-white',
    label: 'Reve'
  },
  ideogram: {
    bg: 'bg-purple-500',
    text: 'text-white',
    label: 'Ideogram'
  },
  leonardo: {
    bg: 'bg-fuchsia-600',
    text: 'text-white',
    label: 'Leonardo.ai'
  },
  midjourney: {
    bg: 'bg-sky-600',
    text: 'text-white',
    label: 'Midjourney'
  },
  runway: {
    bg: 'bg-rose-500',
    text: 'text-white',
    label: 'Runway'
  },
  firefly: {
    bg: 'bg-red-600',
    text: 'text-white',
    label: 'Adobe'
  },
  adobe: {
    bg: 'bg-red-600',
    text: 'text-white',
    label: 'Adobe'
  },
  meta: {
    bg: 'bg-blue-600',
    text: 'text-white',
    label: 'Meta'
  },
  llama: {
    bg: 'bg-blue-600',
    text: 'text-white',
    label: 'Meta'
  },
  amazon: {
    bg: 'bg-orange-400',
    text: 'text-gray-800',
    label: 'Amazon'
  },
  titan: {
    bg: 'bg-orange-400',
    text: 'text-gray-800',
    label: 'Amazon'
  },
  nova: {
    bg: 'bg-orange-400',
    text: 'text-gray-800',
    label: 'Amazon'
  },
  kolors: {
    bg: 'bg-teal-500',
    text: 'text-white',
    label: 'Kuaishou'
  },
  kuaishou: {
    bg: 'bg-teal-500',
    text: 'text-white',
    label: 'Kuaishou'
  },
  krea: {
    bg: 'bg-lime-500',
    text: 'text-gray-800',
    label: 'Krea'
  },
  retro: {
    bg: 'bg-green-200',
    text: 'text-gray-800',
    label: 'Retro Diffusion'
  },
  qwen: {
    bg: 'bg-fuchsia-600',
    text: 'text-white',
    label: 'Qwen'
  },
  luma: {
    bg: 'bg-indigo-500',
    text: 'text-white',
    label: 'Luma'
  },
  minimax: {
    bg: 'bg-blue-500',
    text: 'text-white',
    label: 'Minimax'
  },
  // Texture brands
  realistic: {
    bg: 'bg-slate-600',
    text: 'text-white',
    label: 'scenario'
  },
  texture: {
    bg: 'bg-amber-600',
    text: 'text-white',
    label: ''
  },
  seamless: {
    bg: 'bg-teal-600',
    text: 'text-white',
    label: ''
  }
} as const;
const DEFAULT_CONFIG = {
  bg: 'bg-muted',
  text: 'text-foreground',
  label: ''
};
interface ModelPlaceholderProps {
  modelName: string;
  className?: string;
  /** Hide the brand label and model name (for small thumbnails) */
  compact?: boolean;
  /** Optional tags to check for brand detection */
  tags?: string[];
}

/** Detects brand from model name and tags, returns config */
const getBrandConfig = (modelName: string, tags?: string[]) => {
  const nameLower = modelName.toLowerCase();
  const tagsLower = tags?.map(t => t.toLowerCase()) ?? [];
  for (const [brand, config] of Object.entries(BRAND_CONFIG)) {
    if (nameLower.includes(brand) || tagsLower.some(t => t.includes(brand))) return config;
  }
  return DEFAULT_CONFIG;
};

/** Formats model name for display - splits into lines and uppercases */
const formatModelName = (name: string): string[] => {
  // Split by common separators and filter empty parts
  const parts = name.split(/[\s\-_]+/).filter(Boolean);

  // Group into max 2-3 lines
  if (parts.length <= 2) return parts.map(p => p.toUpperCase());

  // For longer names, try to balance lines
  const midpoint = Math.ceil(parts.length / 2);
  return [parts.slice(0, midpoint).join(' ').toUpperCase(), parts.slice(midpoint).join(' ').toUpperCase()];
};

/** Placeholder component for models without thumbnails */
export const ModelPlaceholder = t0 => {
  const $ = _c(17);
  const {
    modelName,
    className,
    compact,
    tags
  } = t0;
  let config;
  let t1;
  let t2;
  let t3;
  if ($[0] !== className || $[1] !== compact || $[2] !== modelName || $[3] !== tags) {
    config = getBrandConfig(modelName, tags);
    const nameLines = formatModelName(modelName);
    t1 = cn("relative flex flex-col items-start justify-start overflow-hidden", compact ? "p-1" : "p-3", "bg-gradient-to-br from-white/10 to-transparent", config.bg, config.text, className);
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_1px_1px,currentColor_1.5px,transparent_0)] bg-[length:10px_10px]" />;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t3 = !compact && <div className="relative flex flex-col gap-0.5">{nameLines.map(_temp)}</div>;
    $[0] = className;
    $[1] = compact;
    $[2] = modelName;
    $[3] = tags;
    $[4] = config;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    config = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[9] !== compact || $[10] !== config) {
    t4 = !compact && config.label && <span className="absolute bottom-2 right-2 text-xs font-semibold opacity-90 backdrop-blur-xs px-1.5 py-0.5 rounded-sm bg-black/10">{config.label}</span>;
    $[9] = compact;
    $[10] = config;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <div className={t1}>{t2}{t3}{t4}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
ModelPlaceholder.displayName = 'ModelPlaceholder';
function _temp(line, i) {
  return <span key={i} className="text-base font-bold leading-tight drop-shadow-md tracking-tight">{line}</span>;
}